import { render, staticRenderFns } from "./Occupancy.vue?vue&type=template&id=4bb6f52b&scoped=true"
import script from "./Occupancy.vue?vue&type=script&setup=true&lang=js"
export * from "./Occupancy.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Occupancy.vue?vue&type=style&index=0&id=4bb6f52b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb6f52b",
  null
  
)

export default component.exports